"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var FlashMessage = /*#__PURE__*/function () {
  function FlashMessage() {
    _classCallCheck(this, FlashMessage);

    this._flashMessageSuccess = $("#flash.success");
    this._flashMessageError = $("#flash.error");
    this.hideSuccessFlashMessageTimout = 3000;
    this.hideSuccessFlashMessage();
    this.handleCloseFlashMessage();
  }

  _createClass(FlashMessage, [{
    key: "hideSuccessFlashMessage",
    value: function hideSuccessFlashMessage() {
      var _this = this;

      setTimeout(function () {
        _this._flashMessageSuccess.fadeOut('slow');
      }, this.hideSuccessFlashMessageTimout);
    }
  }, {
    key: "handleCloseFlashMessage",
    value: function handleCloseFlashMessage() {
      var _this2 = this;

      $(".close", this._flashMessageError).click(function () {
        _this2._flashMessageError.fadeOut('slow');
      });
    }
  }]);

  return FlashMessage;
}();